/**
 * GUID.js
 * 
 * Created on Oct 9, 2013, 3:19:18 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class GUIDUtil {
    static s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    static generateGUID() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }
}